export default function scrollFactory({
  featureContainer,
  centerHeroCard,
  videoContainer,
  sliderContainerMain,
  heroCardOne,
  heroCardTwo,
  heroCardThree,
  videoCardOne,
  videoCardTwo,
  videoCardThree,
  videoCardFour,
  sliderContainerOne,
  sliderContainerTwo,
  tiltedCard,
  homeFeatureOne,
  homeFeatureTwo,
  homeFeatureThree,
  homeFeatureFour,
  homeAsset1,
  homeAsset2,
  homeAsset3,
  homeAsset4,
}) {
  let centerHeroTop;
  let videoContainerTop;
  let sliderContainerHeight;
  let sliderContainerTop;
  let featureContainerHeight;
  let featureContainerTop;

  function animatePosY() {
    const posY = Math.min(window.pageYOffset / centerHeroTop, 1);
    // console.log('posY:', posY);

    /// card-1
    heroCardOne.current.style.transform = `translate3d(${posY * 200}% , ${
      posY * 400
    }%, 0) rotate(${-20 + posY * 40}deg) scale(${1 - posY * 0.2})`;
    heroCardOne.current.style.opacity = `${1 - posY * 0.8}`;

    /// //card-2
    heroCardTwo.current.style.transform = `translate3d(${posY * 200}% , ${
      posY * 400
    }%, 0) rotate(${-20 + posY * 40}deg) scale(${1 - posY * 0.2})`;
    heroCardTwo.current.style.opacity = `${1 - posY * 0.8}`;

    /// ///card-3
    heroCardThree.current.style.transform = `translate3d(${posY * -200}% , ${
      posY * 400
    }%, 0) rotate(${15 - posY * 30}deg) scale(${1 - posY * 0.2})`;
    heroCardThree.current.style.opacity = `${1 - posY}`;

    /// //center-card
    centerHeroCard.current.classList.toggle('popup', posY > 0.9);
  }
  function animatePosYMobile() {
    const posY = Math.min(window.pageYOffset / centerHeroTop, 1);
    // console.log('posY:', posY);

    /// //card-2
    heroCardTwo.current.style.transform = `translate3d(${posY * 150}% , ${
      posY * 300
    }%, 0) rotate(${-20 + posY * 40}deg) scale(${1 - posY * 0.2})`;
    heroCardTwo.current.style.opacity = `${1 - posY * 0.8}`;

    /// ///card-3
    heroCardThree.current.style.transform = `translate3d(${posY * -100}% , ${
      posY * 300
    }%, 0) rotate(${15 - posY * 30}deg) scale(${1 - posY * 0.2})`;
    heroCardThree.current.style.opacity = `${1 - posY}`;

    /// //center-card
    centerHeroCard.current.classList.toggle('popup', posY > 0.9);
  }

  function animatePosY1() {
    const posY1 = Math.min(
      Math.max(window.pageYOffset - centerHeroTop, 0) /
        (videoContainerTop * 0.8 - centerHeroTop),
      1,
    );
    // console.log('posY1:', posY1);

    videoCardOne.current.style.transform = `translate3d(${
      200 - posY1 * 200
    }px, 0, 0)`;
    videoCardTwo.current.style.transform = `translate3d(${
      -220 + posY1 * 220
    }px, 0, 0)`;
    videoCardThree.current.style.transform = `translate3d(${
      220 - posY1 * 220
    }px , ${-100 + posY1 * 100}px, 0)`;
    videoCardFour.current.style.transform = `translate3d(${
      -220 + posY1 * 220
    }px, 0, 0)`;
  }

  function animatePosY2() {
    const posY2 = Math.min(
      Math.max(
        window.pageYOffset + sliderContainerHeight * 1.5 - sliderContainerTop,
        0,
      ) /
        (sliderContainerHeight * 2.6),
      1,
    );
    // console.log('posY2:', posY2);

    sliderContainerOne.current.style.transform = `translate3d(${
      posY2 * 400
    }px, 0, 0)`;
    sliderContainerTwo.current.style.transform = `translate3d(${
      posY2 * -400
    }px, 0, 0)`;
  }

  function animatePosY3() {
    const posY3 = Math.min(
      Math.max(
        window.pageYOffset + featureContainerHeight * 2.4 - featureContainerTop,
        0,
      ) /
        (featureContainerHeight * 3),
      1,
    );
    // console.log('posY3:', posY3);
    featureContainer.current.style.transform = `translate3d(${
      100 + posY3 * -400
    }px, 0, 0)`;
    featureContainer.current.style.willChange = `transform`;
    tiltedCard.current.style.transform = `rotate(${posY3 * -7}deg)`;
  }
  function animatePosY3Mobile() {
    const posY3 = Math.min(
      Math.max(
        window.pageYOffset + featureContainerHeight * 2 - featureContainerTop,
        0,
      ) /
        (featureContainerHeight * 1.8),
      1,
    );
    // console.log('posY3:', posY3);
    featureContainer.current.style.transform = `translate3d(${
      posY3 * -800
    }px, 0, 0)`;
    tiltedCard.current.style.transform = `rotate(${posY3 * -7}deg)`;
  }

  let prevPageYOffset;

  /// ////////////// //hero animation
  return function () {
    centerHeroTop = centerHeroCard.current?.offsetTop || 0;
    videoContainerTop = videoContainer.current?.offsetTop || 0;
    sliderContainerHeight = sliderContainerMain.current?.offsetHeight || 0;
    sliderContainerTop = sliderContainerMain.current?.offsetTop || 0;
    featureContainerHeight = featureContainer.current?.offsetHeight || 0;
    featureContainerTop = featureContainer.current?.offsetTop || 0;
    // console.log(window.pageYOffset);

    /// /////header hide on srcoll
    const head = document.querySelector('.header');
    if (head) {
      head.classList.toggle(
        'hide',
        window.pageYOffset > 100 && window.pageYOffset > prevPageYOffset,
      );
    }

    prevPageYOffset = window.pageYOffset;
    /// /////

    /// ////////feature-asset
    if (window.innerWidth > 767) {
      if (
        window.pageYOffset + homeFeatureOne.current.offsetHeight * 2 >
          homeFeatureOne.current.offsetTop &&
        window.pageYOffset < homeFeatureOne.current.offsetTop
      ) {
        homeAsset1.current.classList.add('is-active');
        homeAsset2.current.classList.remove('is-active');
        homeAsset3.current.classList.remove('is-active');
        homeAsset4.current.classList.remove('is-active');
      } else if (
        window.pageYOffset > homeFeatureOne.current.offsetTop &&
        window.pageYOffset < homeFeatureTwo.current.offsetTop
      ) {
        homeAsset1.current.classList.remove('is-active');
        homeAsset2.current.classList.add('is-active');
        homeAsset3.current.classList.remove('is-active');
        homeAsset4.current.classList.remove('is-active');
      } else if (
        window.pageYOffset > homeFeatureTwo.current.offsetTop &&
        window.pageYOffset < homeFeatureThree.current.offsetTop
      ) {
        homeAsset1.current.classList.remove('is-active');
        homeAsset2.current.classList.remove('is-active');
        homeAsset3.current.classList.add('is-active');
        homeAsset4.current.classList.remove('is-active');
      } else if (
        window.pageYOffset > homeFeatureThree.current.offsetTop &&
        window.pageYOffset < homeFeatureFour.current.offsetTop
      ) {
        homeAsset1.current.classList.remove('is-active');
        homeAsset2.current.classList.remove('is-active');
        homeAsset3.current.classList.remove('is-active');
        homeAsset4.current.classList.add('is-active');
      } else if (
        window.pageYOffset > homeFeatureFour.current.offsetTop ||
        window.pageYOffset + homeFeatureOne.current.offsetHeight * 2 <
          homeFeatureOne.current.offsetTop
      ) {
        homeAsset1.current.classList.remove('is-active');
        homeAsset2.current.classList.remove('is-active');
        homeAsset3.current.classList.remove('is-active');
        homeAsset4.current.classList.remove('is-active');
      }
    }

    /// /////////
    if (window.pageYOffset < window.innerHeight) {
      if (window.innerWidth > 767) {
        requestAnimationFrame(animatePosY);
      } else {
        requestAnimationFrame(animatePosYMobile);
      }
    }
    if (
      window.innerWidth > 990 &&
      window.pageYOffset > centerHeroTop &&
      window.pageYOffset < videoContainerTop * 1.5
    ) {
      requestAnimationFrame(animatePosY1);
    } else if (
      window.pageYOffset + sliderContainerHeight * 1.5 > sliderContainerTop &&
      window.pageYOffset < sliderContainerTop + sliderContainerHeight * 1.5
    ) {
      requestAnimationFrame(animatePosY2);
    } else if (
      window.pageYOffset + featureContainerHeight * 2.4 > featureContainerTop &&
      window.pageYOffset < featureContainerTop + featureContainerHeight * 1.4
    ) {
      if (window.innerWidth > 767) {
        requestAnimationFrame(animatePosY3);
      } else {
        requestAnimationFrame(animatePosY3Mobile);
      }
    }
  };
}
